import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs/Observable';
import { LoggedInUser, SessionData } from '../../models/loggedinuser.model';

@Injectable()
export class AuthService {
  user: LoggedInUser = null;
  sessionHelper: SessionData = null;
  storageType = '';
  url = '/oauth2/token';
  url_v2 = '/koncentro-auth/token'
  oauthBaseAuth = 'ellUUjF2ZkJGY3pGc1hYamFqSGFZN3VJZ3dBYTpRc19wUDU2ZkQ0dW5JeGx5TnpMaWU1Z0FpT0Fh';

  constructor(
    private h: Http,
    private srvLocalStorage: LocalStorageService,
    private srvNotify: MessageService,
    private router: Router) {
  }

  /*
  Funzione di refresh del token:

     - riprende i dati dell'utente dal local storage o dal session storage
     - invoca un refresh passando per MS e non direttamente dall'IS
     - aggiorna il token e il refreshToken
     - se la chiamata di refresh va male, si eliminano i dati del local e session storage e si torna al login

  */

  refreshToken_v2() {
    console.log('Refreshing token called...');

    if (this.srvLocalStorage.get('userData')) {
      this.user = this.srvLocalStorage.get('userData');
      this.storageType = 'local';
    } else if (sessionStorage.getItem('userData')) {
      this.user = JSON.parse(sessionStorage.getItem('userData'));
      this.storageType = 'session';
    }

    this.h.post(
      this.url_v2 + '/' + 'refresh',
      {token: this.user.refreshToken}
    ).subscribe(res => {
      /*
      console.log("RESPONSE TOKEN: " + res);
      console.log("RES.OK: " + res.ok);
      console.log("RES._body: " + res["_body"]);
      console.log("TOKEN INFO: " + JSON.parse(res["_body"]).rsp_data);
      */
      if (res.ok) {

        let newTokenInfo = JSON.parse(res['_body']).rsp_data;

        if (newTokenInfo) {
          this.user.token = newTokenInfo.access_token;
          this.user.refreshToken = newTokenInfo.refresh_token;
          let now = new Date();
          let expireSeconds = newTokenInfo.expires_in;
          // expireSeconds = 3 * 60; //per prova
          let secondsNow = now.getSeconds();
          now.setSeconds(secondsNow + expireSeconds);
          this.user.tokenExpireDate = now;
          if (this.storageType === 'local') {
            this.srvLocalStorage.set('userData', this.user);
          } else if (this.storageType === 'session') {
            sessionStorage.setItem('userData', JSON.stringify(this.user));
          }
          this.srvNotify.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Token Refreshed!'
          });
          console.log('Token refreshed');
        } else {
          console.log('No new Token Info --> Back to Login');
         // this.backToLogin();
        }
      } else {
        console.log('Refreshing call gone WRONG --> Back to Login');
       // this.backToLogin();
      }
    });

  }

  // login che non va direttamente con l'IS ma passa da MS
  login_v2(username: string, password: string): Observable<any> {
    return this.h.post(
      this.url_v2 + '/' + 'request',
      {username: username, password: password}
    ).map(res => {
      return res;
    });
  }

  checkTokenLogin() {

    let userData: LoggedInUser;

    if (this.srvLocalStorage.get('userData')) {
      this.storageType = 'local';
      if (new Date(this.user.tokenExpireDate) > new Date) {
        this.router.navigateByUrl('');
      } else this.logout()
    } else if (sessionStorage.getItem('userData')) {
      this.storageType = 'session';
      this.router.navigateByUrl('');
    } else {
      this.router.navigateByUrl('login');
    }

  }

  // utilizzato nell'app.component all'interno del setInterval per poter controllore periodicamente la validità del token
  checkTokenInterval() {
    console.log('checkTokenInterval CALLED')

    let userData: LoggedInUser;

    if (this.srvLocalStorage.get('userData')) {
      userData = this.srvLocalStorage.get('userData');
      this.storageType = 'local';
    } else if (sessionStorage.getItem('userData')) {
      userData = JSON.parse(sessionStorage.getItem('userData'));
      this.storageType = 'session';
    } else {
     this.router.navigateByUrl('login');
    }

    if (userData && this.storageType !== '') {
      let now: Date = new Date();
      let tokenExp: Date = new Date(userData.tokenExpireDate.toString());
      let expire = tokenExp.getTime() - (userData.tokenMinuteLimit * 1000 * 60);

      /* per monitorare */
      /*
      let expireMinutes = Math.abs(Math.floor((now.getTime() - expire) / (1000 * 60)));
      console.log("Token expires in " + expireMinutes + " minutes");
      */

      // se il token entro tokenMinuteLimit è scaduto, c'è bisogno di refresh
      if ((now.getTime() - expire) > 0) {

        // caso token non più valido, in scadenza a breve, c'è bisogno di refresh
        // console.log("Token must refresh");
        this.refreshToken_v2();
      } else {
        // caso token valido, OK puoi continuare
        // console.log("Token still valid");
      }
    }

  }

  checkLoginData() {
    let userData: LoggedInUser;

    if (this.srvLocalStorage.get('userData')) {
      userData = this.srvLocalStorage.get('userData');
      this.storageType = 'local';
      this.user = userData;
    } else if (sessionStorage.getItem('userData')) {
      userData = JSON.parse(sessionStorage.getItem('userData'));
      this.storageType = 'session';
      this.user = userData;
    } else {
      // this.router.navigateByUrl('login');
      this.backToLogin();
    }
  }

  backToLogin() {
    this.user = null;
    this.srvLocalStorage.remove('userData');
    sessionStorage.removeItem('userData');
    sessionStorage.removeItem('menu');
    this.router.navigateByUrl('login');
  }

  logout() : void {
    this.user = null;
    this.srvLocalStorage.remove('userData');
    this.srvLocalStorage.remove('koncentroMenuParent');
    this.srvLocalStorage.remove('koncentroMenuActive');
    sessionStorage.removeItem('menu');
    sessionStorage.removeItem('userData');
    this.router.navigateByUrl('login');
  }

}



// WEBPACK FOOTER //
// ./src/app/services/user/auth.service.ts